import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { DeliveryLocations } from "../../financial.types";

export const requestDeliveryLocations =
  async (): Promise<DeliveryLocations> => {
    return await instance.get(ApiRoutesDeliveryFees.DeliveryLocations);
  };
